import type { NextWebVitalsMetric } from 'next/app';

import { sendWebVitals } from '@src/services/webVitals';
import { MyApp } from 'app/MyApp';
// eslint-disable-next-line import/no-unassigned-import
import '@src/styles/global.scss';

export function reportWebVitals(metric: NextWebVitalsMetric) {
  sendWebVitals(metric);
}

export default MyApp;
